import moment from 'moment';
import { ChipColors } from '../../../components/designSystem/Chip/Chip.types';
import {
  Consultation,
  ConsultationMatches,
} from '../../../types/models/consultations/consultation.types';

export const getChipContentByStepId = (
  consultation: Consultation | (Consultation & ConsultationMatches)
) => {
  switch (consultation.id_step) {
    case 1:
      return {
        label: 'Brouillon',
        color: ChipColors.Warning,
      };
    case 2:
      return {
        label: 'Brouillon',
        color: ChipColors.Info,
      };
    case 3:
      return {
        label: 'Brouillon',
        color: ChipColors.Primary,
      };
    case 4:
      if (moment().isBefore(consultation.start)) {
        return {
          label: 'Programmée',
          color: ChipColors.Secondary,
        };
      } else if (moment().isBefore(moment(consultation.end).hours(22))) {
        return {
          label: 'En cours',
          color: ChipColors.Secondary,
        };
      } else {
        return {
          label: 'Terminée',
          color: ChipColors.Alert,
        };
        // switch ((consultation as Consultation & ConsultationMatches).status) {
        //   case 1:
        //     return {
        //       label: 'En attente de devis',
        //       color: ChipColors.Secondary,
        //     };
        //   case 2:
        //     return {
        //       label: 'Devis déposé',
        //       color: ChipColors.Secondary,
        //     };
        //   default:
        //     return {
        //       label: 'Clôturé',
        //       color: ChipColors.Alert,
        //     };
        // }
      }
    case 5:
      return {
        label: 'Clôturée',
        color: ChipColors.Success,
      };
    case 6:
      return {
        label: 'Archivée',
        color: ChipColors.Success,
      };
    default:
      return {
        label: 'Statut inconnu',
        color: ChipColors.Warning,
      };
  }
};
